import Swiper from 'swiper'

export default class sales {
  constructor() {
    new Swiper('.swiper-container', {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: '.p-swiper-page',
        disabledClass: '.disabled',
      },
      navigation: {
        nextEl: '.next',
        prevEl: '.prev',
      },
    })
}
}


// WEBPACK FOOTER //
// ./dev/js/sales.js